import { createSlice } from "@reduxjs/toolkit";
import { getDashboardData } from "../services/dashboard-services";

const initialState = {
    dashboardDatas: [],
    dashboardData: null,
    pagination: null,
    error: [],
    loading: false,
    responseMessage: null,
    success: false,
    successMessage: null,
    deleteResponse: false,
    errorMessage: null,
};

export const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getDashboardData.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getDashboardData.fulfilled, (state, action) => {
                state.dashboardDatas = action.payload.data.item;

                state.pagination = action.payload.data.item;
                state.currentPage = action.payload.data.item;
                state.loading = false;

            })
            .addCase(getDashboardData.rejected, (state, action) => {
                state.loading = false;
            })

    },
});

export const error = (state) => state.error;
export const loading = (state) => state.loading;
export default dashboardSlice.reducer;
